import { useEffect } from "react";

/**
 * Scrolls the first errored form field into view whenever the errors object
 * changes. Works with react-hook-form's `errors` and any supplementary error
 * messages keyed by field name.
 *
 * Field names map to DOM via:
 *   1. document.getElementById(name) — matches most shared inputs
 *   2. document.getElementsByName(name)[0] — fallback for fields without id
 */
const useScrollToFirstError = (errors, extraErrors = {}) => {
  useEffect(() => {
    const errorKeys = [
      ...Object.keys(errors || {}),
      ...Object.keys(extraErrors || {}).filter((k) => !!extraErrors[k]),
    ];
    if (errorKeys.length === 0) return;

    const firstKey = errorKeys[0];
    const el =
      document.getElementById(firstKey) ||
      document.getElementsByName(firstKey)[0];
    if (el && typeof el.scrollIntoView === "function") {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(Object.keys(errors || {}))]);
};

export default useScrollToFirstError;
